import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Form, Button, Card, Row, Col, Accordion, Alert } from 'react-bootstrap';

export default function UkiesFAQ({ componentSettings, setComponentSettings, onChange, selectedComponent, setSelectedComponent }) {
    const [isInitialized, setIsInitialized] = useState(false);
    const [answerSourceCodeModes, setAnswerSourceCodeModes] = useState({});
    const [editingCategoryIndex, setEditingCategoryIndex] = useState(null);
    const [draggedCategoryIndex, setDraggedCategoryIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [dropIndicatorPosition, setDropIndicatorPosition] = useState(null); // 'before' or 'after'
    const [openAccordions, setOpenAccordions] = useState([]);
    const [openQuestionAccordions, setOpenQuestionAccordions] = useState({});
    const [editingQuestionIndex, setEditingQuestionIndex] = useState(null);
    const [draggedQuestionIndex, setDraggedQuestionIndex] = useState(null);
    const [draggedQuestionCategoryIndex, setDraggedQuestionCategoryIndex] = useState(null);
    const [dragOverQuestionIndex, setDragOverQuestionIndex] = useState(null);
    const [questionDropIndicatorPosition, setQuestionDropIndicatorPosition] = useState(null);
    const [preDragAccordionState, setPreDragAccordionState] = useState([]);
    const answerEditorRefs = useRef({});

    // Get current values with defaults
    const title = componentSettings.title || 'Veelgestelde vragen';
    const showSearch = componentSettings.showSearch !== false; // Default to true
    const defaultOpenCategory = componentSettings.defaultOpenCategory || 'geen';
    const categories = componentSettings.categories || [
        {
            id: 'cat-1',
            name: 'Algemeen',
            questions: [
                {
                    id: 'q-1',
                    question: 'Wat is dit?',
                    answer: '<p>Dit is een voorbeeld vraag en antwoord.</p>'
                }
            ]
        }
    ];

    // Parse HTML content to extract FAQ configuration
    const parseHTMLContent = (htmlContent) => {
        if (!htmlContent) return null;
        
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');
            
            const mainDiv = doc.querySelector('.ukies-faq');
            if (!mainDiv) return null;
            
            // Extract title
            const titleEl = mainDiv.querySelector('.component-text .header-text');
            const extractedTitle = titleEl ? titleEl.textContent.trim() : 'Veelgestelde vragen';
            
                         // Extract search bar visibility
             const searchEl = mainDiv.querySelector('.component-search');
             const extractedShowSearch = !!searchEl;
             
             // Extract categories and questions
            const categoryElements = mainDiv.querySelectorAll('.component-accordion .tab__main');
            const extractedCategories = [];
            
            categoryElements.forEach((categoryEl, categoryIndex) => {
                const categoryLabel = categoryEl.querySelector('.tab__label span');
                const categoryName = categoryLabel ? categoryLabel.textContent.trim() : `Categorie ${categoryIndex + 1}`;
                
                const questions = [];
                const questionElements = categoryEl.querySelectorAll('.component-accordion--sub .tab__sub');
                
                questionElements.forEach((questionEl, questionIndex) => {
                    const questionLabel = questionEl.querySelector('.tab__label span');
                    const questionText = questionLabel ? questionLabel.textContent.trim() : '';
                    
                    const answerEl = questionEl.querySelector('.tab__content');
                    const answerHtml = answerEl ? answerEl.innerHTML.trim() : '';
                    
                    if (questionText) {
                        questions.push({
                            id: `q-${categoryIndex + 1}-${questionIndex + 1}`,
                            question: questionText,
                            answer: answerHtml
                        });
                    }
                });
                
                if (categoryName) {
                    extractedCategories.push({
                        id: `cat-${categoryIndex + 1}`,
                        name: categoryName,
                        questions: questions
                    });
                                 }
             });
             
             // Extract default open category from checked input (after categories are extracted)
             const checkedCategoryInput = mainDiv.querySelector('.tab__input[name^="accordion-"]:checked:not([name*="sub"])');
             let extractedDefaultOpenCategory = 'geen';
             if (checkedCategoryInput) {
                 const categoryMatch = checkedCategoryInput.getAttribute('name').match(/accordion-(\d+)/);
                 if (categoryMatch) {
                     const categoryNumber = parseInt(categoryMatch[1]) - 1;
                     // Map the position back to the actual category ID from extracted categories
                     if (extractedCategories[categoryNumber]) {
                         extractedDefaultOpenCategory = extractedCategories[categoryNumber].id;
                     }
                 }
             }
             
             return {
                title: extractedTitle,
                showSearch: extractedShowSearch,
                defaultOpenCategory: extractedDefaultOpenCategory,
                categories: extractedCategories.length > 0 ? extractedCategories : [
                    {
                        id: 'cat-1',
                        name: 'Algemeen',
                        questions: [
                            {
                                id: 'q-1',
                                question: 'Wat is dit?',
                                answer: '<p>Dit is een voorbeeld vraag en antwoord.</p>'
                            }
                        ]
                    }
                ]
            };
        } catch (error) {
            console.error('Error parsing HTML content:', error);
            return null;
        }
    };

    // HTML escaping function
    const escapeHtml = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    };

    // Generate HTML content from current form values
    const generateHTMLContent = () => {
        return generateHTMLContentWithSettings(componentSettings);
    };

    // Generate HTML content with specific settings
    const generateHTMLContentWithSettings = (settings) => {
        const titleData = settings.title || title;
        const showSearchData = settings.showSearch !== false; // Default to true
        const defaultOpenCategoryData = settings.defaultOpenCategory || 'geen';
        const categoriesData = settings.categories || categories;
        
        // Generate search component (conditionally)
        const searchComponent = showSearchData ? `    <div class='component component-search'>
        <form onsubmit='return filterFAQ(this)'>
            <div class='eui-input-wrapper' style='border-radius:var(--eui-spec-radius-default) 0 0 var(--eui-spec-radius-default);'>
                <input class='eui-input' name='search' type='search'>
            </div>
            <button type="submit">
                <span class="svg-icon svg-icon-primary svg-icon-2x">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24"/>
                            <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#ffffff" fill-rule="nonzero" opacity="0.8"/>
                            <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#ffffff" fill-rule="nonzero"/>
                        </g>
                    </svg>
                </span>
            </button>
        </form>
    </div>
` : '';

        // Generate category accordions
        const categoryComponents = categoriesData.map((category, categoryIndex) => {
            const categoryId = `accordion-${categoryIndex + 1}`;
            
            // Check if this category should be the default open one
            const isDefaultOpen = defaultOpenCategoryData !== 'geen' && defaultOpenCategoryData === category.id;
            const checkedAttribute = isDefaultOpen ? ' checked' : '';
            
            // Generate questions for this category
            const questionComponents = category.questions.map((question, questionIndex) => {
                const questionId = `accordion-${categoryIndex + 1}-sub-${questionIndex + 1}`;
                
                return `                    <div class='tab tab__sub'>
                        <input type='checkbox' class='tab__input' name='${questionId}' id='${questionId}'>
                        <label for='${questionId}' class='tab__label'><span>${escapeHtml(question.question)}</span></label>
                        <div class='tab__content component component-text'>
                            ${question.answer}
                        </div>
                    </div>`;
            }).join('\n');

            return `    <section class='component component-accordion'>
        <div class='tab tab__main'>
            <input type='checkbox' class='tab__input' name='${categoryId}' id='${categoryId}'${checkedAttribute}>
            <label for='${categoryId}' class='tab__label'><span>${escapeHtml(category.name)}</span></label>
            <div class='tab__content'>
                <section class='component component-accordion component-accordion--sub'>
${questionComponents}
                </section>
            </div>
        </div>
    </section>`;
        }).join('\n');

        const htmlContent = `<div class='structure structure-1 gap-extrasmall ukies-faq'>
    <div class='component component-text'>
        <div class='header-text'>${escapeHtml(titleData)}</div>
    </div>
${searchComponent}
${categoryComponents}
</div>`;

        return htmlContent;
    };

    // Initialize form values from HTML content on component mount
    useEffect(() => {
        if (selectedComponent?.content && !isInitialized) {
            const parsed = parseHTMLContent(selectedComponent.content);
            if (parsed) {
                setComponentSettings(prev => ({
                    ...prev,
                    title: parsed.title,
                    showSearch: parsed.showSearch,
                    defaultOpenCategory: parsed.defaultOpenCategory,
                    categories: parsed.categories
                }));
            }
            setIsInitialized(true);
        }
    }, [selectedComponent?.content, isInitialized, setComponentSettings]);

    // Reset initialization when component changes
    useEffect(() => {
        setIsInitialized(false);
        setAnswerSourceCodeModes({});
        setEditingCategoryIndex(null);
        setEditingQuestionIndex(null);
        setDraggedCategoryIndex(null);
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
        setDraggedQuestionIndex(null);
        setDraggedQuestionCategoryIndex(null);
        setDragOverQuestionIndex(null);
        setQuestionDropIndicatorPosition(null);
        // Initialize all accordions as closed by default
        setOpenAccordions([]);
        setOpenQuestionAccordions({});
        setPreDragAccordionState([]);
        answerEditorRefs.current = {};
    }, [selectedComponent?.id, categories.length]);

    // Update HTML content when settings change
    const updateHTMLContent = () => {
        const newContent = generateHTMLContent();
        
        setComponentSettings(prev => ({
            ...prev,
            content: newContent
        }));
        
        onChange('content', newContent);
    };

    // Update HTML content with specific settings (for immediate updates)
    const updateHTMLContentWithSettings = (settings) => {
        const newContent = generateHTMLContentWithSettings(settings);
        
        setComponentSettings(prev => ({
            ...prev,
            content: newContent
        }));
        
        onChange('content', newContent);
    };

    // Handle title change
    const handleTitleChange = (newTitle) => {
        const newComponentSettings = {
            ...componentSettings,
            title: newTitle
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle show search change
    const handleShowSearchChange = (newShowSearch) => {
        const newComponentSettings = {
            ...componentSettings,
            showSearch: newShowSearch
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle default open category change
    const handleDefaultOpenCategoryChange = (newDefaultOpenCategory) => {
        const newComponentSettings = {
            ...componentSettings,
            defaultOpenCategory: newDefaultOpenCategory
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle category changes
    const handleCategoryChange = (categoryIndex, field, value) => {
        const newCategories = [...categories];
        newCategories[categoryIndex] = {
            ...newCategories[categoryIndex],
            [field]: value
        };
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Add new category
    const addCategory = () => {
        const newCategory = {
            id: `cat-${Date.now()}`,
            name: 'Nieuwe categorie',
            questions: []
        };
        
        const newCategories = [...categories, newCategory];
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Delete category
    const deleteCategory = (categoryIndex) => {
        const categoryName = categories[categoryIndex].name;
        const questionCount = categories[categoryIndex].questions.length;
        
        const confirmMessage = questionCount > 0 
            ? `Weet je zeker dat je de categorie "${categoryName}" wilt verwijderen? Dit verwijdert ook alle ${questionCount} vragen in deze categorie.`
            : `Weet je zeker dat je de categorie "${categoryName}" wilt verwijderen?`;
            
        if (!window.confirm(confirmMessage)) {
            return;
        }
        
                 const categoryToDelete = categories[categoryIndex];
         const newCategories = categories.filter((_, index) => index !== categoryIndex);
         
         // If the deleted category was the default open category, reset to "geen"
         let newDefaultOpenCategory = defaultOpenCategory;
         if (defaultOpenCategory === categoryToDelete.id) {
             newDefaultOpenCategory = 'geen';
         }
         
         const newComponentSettings = {
             ...componentSettings,
             categories: newCategories,
             defaultOpenCategory: newDefaultOpenCategory
         };
         
         setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Move category up/down
    const moveCategoryUp = (categoryIndex) => {
        if (categoryIndex === 0) return;
        
        const newCategories = [...categories];
        [newCategories[categoryIndex - 1], newCategories[categoryIndex]] = 
        [newCategories[categoryIndex], newCategories[categoryIndex - 1]];
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    const moveCategoryDown = (categoryIndex) => {
        if (categoryIndex === categories.length - 1) return;
        
        const newCategories = [...categories];
        [newCategories[categoryIndex], newCategories[categoryIndex + 1]] = 
        [newCategories[categoryIndex + 1], newCategories[categoryIndex]];
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Drag and drop handlers for category reordering
    const handleCategoryDragStart = (e, categoryIndex) => {
        setDraggedCategoryIndex(categoryIndex);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.outerHTML);
        
        // Save current accordion state before closing them for drag
        setPreDragAccordionState(openAccordions);
        
        // Close all accordions during drag
        setOpenAccordions([]);
        
        // Add some styling to the drag image
        e.target.style.opacity = '0.5';
    };

    const handleCategoryDragEnd = (e) => {
        e.target.style.opacity = '1';
        setDraggedCategoryIndex(null);
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
        
        // Keep accordions closed after drag for cleaner interface
        setOpenAccordions([]);
    };

    const handleCategoryDragOver = (e, categoryIndex) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        
        if (draggedCategoryIndex !== null && categoryIndex !== draggedCategoryIndex) {
            const rect = e.currentTarget.getBoundingClientRect();
            const y = e.clientY - rect.top;
            const height = rect.height;
            
            // Determine if we're in the top or bottom half
            const position = y < height / 2 ? 'before' : 'after';
            
            setDragOverIndex(categoryIndex);
            setDropIndicatorPosition(position);
        }
    };

    const handleCategoryDragLeave = () => {
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
    };

    // Handle drag over for the drop zone after the last item
    const handleLastDropZoneDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        
        if (draggedCategoryIndex !== null) {
            setDragOverIndex(categories.length - 1);
            setDropIndicatorPosition('after');
        }
    };

    const handleLastDropZoneDragLeave = () => {
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
    };

    const handleCategoryDrop = (e, dropIndex) => {
        e.preventDefault();
        
        if (draggedCategoryIndex === null) {
            return;
        }

        const newCategories = [...categories];
        const draggedCategory = newCategories[draggedCategoryIndex];
        
        // Remove dragged category from its current position
        newCategories.splice(draggedCategoryIndex, 1);
        
        // Calculate the new insert position
        let insertIndex;
        if (dropIndicatorPosition === 'before') {
            insertIndex = dropIndex;
            if (draggedCategoryIndex < dropIndex) {
                insertIndex = dropIndex - 1;
            }
        } else { // 'after'
            insertIndex = dropIndex + 1;
            if (draggedCategoryIndex < dropIndex) {
                insertIndex = dropIndex;
            }
        }
        
        // Ensure insert index is within bounds
        insertIndex = Math.max(0, Math.min(insertIndex, newCategories.length));
        
        // Insert at the new position
        newCategories.splice(insertIndex, 0, draggedCategory);
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        setDraggedCategoryIndex(null);
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle drop for the last drop zone
    const handleLastDropZoneDrop = (e) => {
        e.preventDefault();
        
        if (draggedCategoryIndex === null) {
            return;
        }

        const newCategories = [...categories];
        const draggedCategory = newCategories[draggedCategoryIndex];
        
        // Remove dragged category from its current position
        newCategories.splice(draggedCategoryIndex, 1);
        
        // Insert at the end
        newCategories.push(draggedCategory);
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        setDraggedCategoryIndex(null);
        setDragOverIndex(null);
        setDropIndicatorPosition(null);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Drag and drop handlers for question reordering
    const handleQuestionDragStart = (e, categoryIndex, questionIndex) => {
        setDraggedQuestionIndex(questionIndex);
        setDraggedQuestionCategoryIndex(categoryIndex);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', '');
        
        // Prevent the drag from affecting accordion behavior
        e.stopPropagation();
        
        // Add some styling to the drag image
        e.target.style.opacity = '0.5';
    };

    const handleQuestionDragEnd = (e) => {
        e.target.style.opacity = '1';
        setDraggedQuestionIndex(null);
        setDraggedQuestionCategoryIndex(null);
        setDragOverQuestionIndex(null);
        setQuestionDropIndicatorPosition(null);
    };

    const handleQuestionDragOver = (e, categoryIndex, questionIndex) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        
        if (draggedQuestionIndex !== null && 
            draggedQuestionCategoryIndex === categoryIndex && 
            questionIndex !== draggedQuestionIndex) {
            const rect = e.currentTarget.getBoundingClientRect();
            const y = e.clientY - rect.top;
            const height = rect.height;
            
            // Determine if we're in the top or bottom half
            const position = y < height / 2 ? 'before' : 'after';
            
            setDragOverQuestionIndex(questionIndex);
            setQuestionDropIndicatorPosition(position);
        }
    };

    const handleQuestionDragLeave = () => {
        setDragOverQuestionIndex(null);
        setQuestionDropIndicatorPosition(null);
    };

    const handleQuestionDrop = (e, categoryIndex, dropIndex) => {
        e.preventDefault();
        
        if (draggedQuestionIndex === null || draggedQuestionCategoryIndex !== categoryIndex) {
            return;
        }

        const newCategories = [...categories];
        const questions = newCategories[categoryIndex].questions;
        const draggedQuestion = questions[draggedQuestionIndex];
        
        // Remove dragged question from its current position
        questions.splice(draggedQuestionIndex, 1);
        
        // Calculate the new insert position
        let insertIndex;
        if (questionDropIndicatorPosition === 'before') {
            insertIndex = dropIndex;
            if (draggedQuestionIndex < dropIndex) {
                insertIndex = dropIndex - 1;
            }
        } else { // 'after'
            insertIndex = dropIndex + 1;
            if (draggedQuestionIndex < dropIndex) {
                insertIndex = dropIndex;
            }
        }
        
        // Ensure insert index is within bounds
        insertIndex = Math.max(0, Math.min(insertIndex, questions.length));
        
        // Insert at the new position
        questions.splice(insertIndex, 0, draggedQuestion);
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        setDraggedQuestionIndex(null);
        setDraggedQuestionCategoryIndex(null);
        setDragOverQuestionIndex(null);
        setQuestionDropIndicatorPosition(null);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Handle question changes
    const handleQuestionChange = (categoryIndex, questionIndex, field, value) => {
        const newCategories = [...categories];
        newCategories[categoryIndex].questions[questionIndex] = {
            ...newCategories[categoryIndex].questions[questionIndex],
            [field]: value
        };
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Add new question
    const addQuestion = (categoryIndex) => {
        const newQuestion = {
            id: `q-${Date.now()}`,
            question: 'Nieuwe vraag',
            answer: '<p>Antwoord op nieuwe vraag.</p>'
        };
        
        const newCategories = [...categories];
        newCategories[categoryIndex].questions.push(newQuestion);
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Delete question
    const deleteQuestion = (categoryIndex, questionIndex) => {
        const questionText = categories[categoryIndex].questions[questionIndex].question;
        
        if (!window.confirm(`Weet je zeker dat je de vraag "${questionText}" wilt verwijderen?`)) {
            return;
        }
        
        const newCategories = [...categories];
        newCategories[categoryIndex].questions = newCategories[categoryIndex].questions.filter((_, index) => index !== questionIndex);
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Move question up/down
    const moveQuestionUp = (categoryIndex, questionIndex) => {
        if (questionIndex === 0) return;
        
        const newCategories = [...categories];
        const questions = newCategories[categoryIndex].questions;
        [questions[questionIndex - 1], questions[questionIndex]] = 
        [questions[questionIndex], questions[questionIndex - 1]];
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    const moveQuestionDown = (categoryIndex, questionIndex) => {
        const questions = categories[categoryIndex].questions;
        if (questionIndex === questions.length - 1) return;
        
        const newCategories = [...categories];
        const categoryQuestions = newCategories[categoryIndex].questions;
        [categoryQuestions[questionIndex], categoryQuestions[questionIndex + 1]] = 
        [categoryQuestions[questionIndex + 1], categoryQuestions[questionIndex]];
        
        const newComponentSettings = {
            ...componentSettings,
            categories: newCategories
        };
        
        setComponentSettings(newComponentSettings);
        
        setTimeout(() => {
            updateHTMLContentWithSettings(newComponentSettings);
        }, 0);
    };

    // Format text functions for rich text editors
    const formatAnswerText = (questionKey, command, value = null) => {
        document.execCommand(command, false, value);
        if (answerEditorRefs.current[questionKey]) {
            answerEditorRefs.current[questionKey].focus();
        }
    };

    // Handle answer text change from contentEditable
    const handleAnswerTextChange = (categoryIndex, questionIndex, e) => {
        const content = e.target.innerHTML;
        if (content === '<p>Voer hier het antwoord in...</p>') {
            handleQuestionChange(categoryIndex, questionIndex, 'answer', '');
        } else {
            handleQuestionChange(categoryIndex, questionIndex, 'answer', content);
        }
    };

    // Handle answer editor click to clear placeholder
    const handleAnswerEditorClick = (questionKey) => {
        const editor = answerEditorRefs.current[questionKey];
        if (editor && editor.innerHTML === '<p>Voer hier het antwoord in...</p>') {
            editor.innerHTML = '<p><br></p>';
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(editor.firstChild, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    // Handle answer source code mode toggle
    const handleAnswerSourceCodeToggle = (categoryIndex, questionIndex) => {
        const questionKey = `${categoryIndex}-${questionIndex}`;
        const isSourceMode = answerSourceCodeModes[questionKey];
        const editor = answerEditorRefs.current[questionKey];
        
        if (isSourceMode && editor) {
            const sourceContent = editor.value;
            handleQuestionChange(categoryIndex, questionIndex, 'answer', sourceContent);
        } else if (!isSourceMode && editor) {
            const wysiwygContent = editor.innerHTML;
            handleQuestionChange(categoryIndex, questionIndex, 'answer', wysiwygContent);
        }
        
        setAnswerSourceCodeModes(prev => ({
            ...prev,
            [questionKey]: !isSourceMode
        }));
    };

    // Handle inline category name editing
    const handleCategoryNameClick = (categoryIndex) => {
        setEditingCategoryIndex(categoryIndex);
    };

    const handleCategoryNameChange = (categoryIndex, newName) => {
        handleCategoryChange(categoryIndex, 'name', newName);
    };

    const handleCategoryNameKeyDown = (e, categoryIndex) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setEditingCategoryIndex(null);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            setEditingCategoryIndex(null);
        }
    };

    const handleCategoryNameBlur = () => {
        setEditingCategoryIndex(null);
    };

    // Handle inline question editing
    const handleQuestionTextClick = (categoryIndex, questionIndex) => {
        setEditingQuestionIndex(`${categoryIndex}-${questionIndex}`);
    };

    const handleQuestionTextChange = (categoryIndex, questionIndex, newText) => {
        handleQuestionChange(categoryIndex, questionIndex, 'question', newText);
    };

    const handleQuestionTextKeyDown = (e, categoryIndex, questionIndex) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setEditingQuestionIndex(null);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            setEditingQuestionIndex(null);
        }
    };

    const handleQuestionTextBlur = () => {
        setEditingQuestionIndex(null);
    };

    // Set initial content for answer editors when data changes
    useEffect(() => {
        categories.forEach((category, categoryIndex) => {
            category.questions.forEach((question, questionIndex) => {
                const questionKey = `${categoryIndex}-${questionIndex}`;
                const editor = answerEditorRefs.current[questionKey];
                const isSourceMode = answerSourceCodeModes[questionKey];
                
                if (editor && question.answer !== undefined) {
                    // Only update editor content if it's not currently focused (being edited)
                    const isFocused = document.activeElement === editor;
                    
                    if (!isFocused) {
                        if (isSourceMode) {
                            editor.value = question.answer || '';
                        } else {
                            editor.innerHTML = question.answer || '<p>Voer hier het antwoord in...</p>';
                        }
                    }
                }
            });
        });
    }, [categories, answerSourceCodeModes]);

    return (
        <div>
            <style jsx>{`
                .add-button-green {
                    background-color: var(--ukies-light-green) !important;
                    border-color: var(--ukies-light-green) !important;
                    color: white !important;
                }
                .add-button-green:hover:not(:disabled) {
                    background-color: var(--ukies-dark-green) !important;
                    border-color: var(--ukies-dark-green) !important;
                    color: white !important;
                }
                .rich-text-editor {
                    font-family: inherit;
                    font-size: 0.9rem;
                    line-height: 1.5;
                }
                .rich-text-editor:focus {
                    border-color: #80bdff !important;
                    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
                }
                .rich-text-editor p {
                    margin-bottom: 0.5rem;
                }
                .rich-text-editor ul, .rich-text-editor ol {
                    margin-bottom: 0.5rem;
                    padding-left: 1.5rem;
                }
                .rich-text-editor a {
                    color: #007bff;
                    text-decoration: underline;
                }
                .accordion-button {
                    background-color: white !important;
                    border: 1px solid #dee2e6 !important;
                    padding-left: 3rem !important;
                    padding-right: 1.25rem !important;
                }
                .accordion-button:not(.collapsed) {
                    background-color: white !important;
                    color: inherit !important;
                    box-shadow: none !important;
                }
                .accordion-button:focus {
                    box-shadow: none !important;
                    border-color: #dee2e6 !important;
                }
                .accordion-button::after {
                    display: none !important;
                }
                .accordion-button::before {
                    content: '';
                    position: absolute;
                    left: 1.25rem;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 0.5rem;
                    height: 0.5rem;
                    border-right: 2px solid currentColor;
                    border-bottom: 2px solid currentColor;
                    transform: translateY(-50%) rotate(45deg);
                    transition: transform 0.2s ease-in-out;
                }
                .accordion-button:not(.collapsed)::before {
                    transform: translateY(-50%) rotate(-135deg);
                }
                .category-controls {
                     background-color: #f8f9fa;
                 }
                                  .question-controls {
                     border-left: 2px solid #28a745;
                     background-color: #f9f9f9;
                 }
                 .question-controls .accordion-button {
                     background-color: #f0f8f0 !important;
                     padding-left: 2rem !important;
                     padding-right: 1rem !important;
                     font-size: 0.9rem;
                 }
                 .question-controls .accordion-button:not(.collapsed) {
                     background-color: #e8f5e8 !important;
                 }
                                   .question-controls .accordion-button::before {
                      left: 0.75rem;
                      width: 0.4rem;
                      height: 0.4rem;
                  }
                  .question-controls .dragging {
                      opacity: 0.5;
                  }
                  .question-controls .drag-over {
                      background-color: #f0f8f0;
                  }
                  .question-controls .drop-indicator {
                      height: 2px;
                      background-color: #28a745;
                      border-radius: 1px;
                      margin: 1px 0;
                      opacity: 0;
                      transition: opacity 0.2s;
                  }
                  .question-controls .drop-indicator.active {
                      opacity: 1;
                  }
                  .editable-category-name {
                      background: transparent;
                      border: none;
                      font-weight: bold;
                      font-size: inherit;
                      width: 100%;
                      outline: none;
                      padding: 0;
                      margin: 0;
                  }
                  .editable-category-name:focus {
                      background-color: white;
                      border: 1px solid #007bff;
                      border-radius: 4px;
                      padding: 4px;
                  }
                                     .drag-handle {
                       cursor: grab;
                       display: flex;
                       align-items: center;
                       justify-content: center;
                       padding: 4px;
                       background-color: #f8f9fa;
                       border: 1px solid #dee2e6;
                       border-radius: 4px;
                       transition: background-color 0.2s;
                       width: 32px;
                       height: 32px;
                   }
                   .drag-handle:hover {
                       background-color: #e9ecef;
                   }
                   .drag-handle:active {
                       cursor: grabbing;
                   }
                   .drag-handle-arrows {
                       display: flex;
                       gap: 2px;
                       font-size: 14px;
                       line-height: 1;
                        color: var(--ukies-dark-green);
                        font-weight: bold;
                   }
                    .dragging {
                       opacity: 0.5;
                   }
                                     .drag-over {
                       background-color: #fff5e6;
                   }
                                                                           .drag-over .accordion-button {
                        background-color: #fff5e6 !important;
                      border-botom: 2px solid var(--ukies-dark-orange);
                    }
                                       .drop-indicator {
                        height: 3px;
                        background-color: var(--ukies-dark-orange);
                        border-radius: 2px;
                        margin: 2px 0;
                        opacity: 0;
                        transition: opacity 0.2s;
                    }
                   .drop-indicator.active {
                       opacity: 1;
                   }
                   .drop-zone-last {
                       height: 20px;
                       border: 2px dashed transparent;
                       border-radius: 4px;
                       margin: 10px 0;
                       transition: border-color 0.2s;
                   }
                                       .drop-zone-last.drag-over {
                        border-color: var(--ukies-dark-orange);
                        background-color: rgba(255, 165, 0, 0.1);
                    }
            `}</style>

            {/* Title Configuration */}
            <h6 className="mb-2 mt-4" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '8px' }}>
                FAQ instellingen
            </h6>
            
            <Form.Group className="mb-4">
                <Form.Label>Titel</Form.Label>
                <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => handleTitleChange(e.target.value)}
                    placeholder="Voer hoofdtitel in"
                />
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Check 
                    type="switch"
                    id="show-search-toggle"
                    label="Zoekbalk tonen"
                    checked={showSearch}
                    onChange={(e) => handleShowSearchChange(e.target.checked)}
                />
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Label>Geopende categorie</Form.Label>
                <Form.Select
                    value={defaultOpenCategory}
                    onChange={(e) => handleDefaultOpenCategoryChange(e.target.value)}
                >
                    <option value="geen">Geen</option>
                    {categories.map((category, index) => (
                        <option key={category.id} value={category.id}>
                            {category.name}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>

            {/* Categories Configuration */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Categorieën</h6>
                <Button 
                    variant="success" 
                    size="sm" 
                    onClick={addCategory}
                    className="add-button-green"
                >
                    + Categorie toevoegen
                </Button>
            </div>

            {categories.length === 0 && (
                <Alert variant="info">
                    Geen categorieën gevonden. Voeg een categorie toe om te beginnen.
                </Alert>
            )}

                <Accordion 
                              className="my-4"
                              activeKey={openAccordions}
                              onSelect={(eventKey) => {
                                  // Prevent accordion toggle when dragging or editing
                                  if (draggedCategoryIndex === null && editingCategoryIndex === null && editingQuestionIndex === null) {
                                      setOpenAccordions(prev => 
                                          prev.includes(eventKey) 
                                              ? prev.filter(key => key !== eventKey)
                                              : [...prev, eventKey]
                                      );
                                  }
                              }}
                              style={{borderTop: '2px solid #dee2e6'}}
                >
                {categories.map((category, categoryIndex) => (
                    <Fragment key={category.id}>
                        {/* Drop indicator before item */}
                        <div 
                            className={`drop-indicator ${
                                dragOverIndex === categoryIndex && dropIndicatorPosition === 'before' ? 'active' : ''
                            }`}
                        />
                        
                        <Accordion.Item 
                            eventKey={categoryIndex.toString()}
                            onDragOver={(e) => handleCategoryDragOver(e, categoryIndex)}
                            onDragLeave={handleCategoryDragLeave}
                            onDrop={(e) => handleCategoryDrop(e, categoryIndex)}
                            className={`${draggedCategoryIndex === categoryIndex ? 'dragging' : ''} ${dragOverIndex === categoryIndex ? 'drag-over' : ''}`}
                        >
                                                         <Accordion.Header>
                                 <div className="d-flex align-items-center justify-content-between w-100">
                                     <div className="flex-grow-1 me-3">
                                        {editingCategoryIndex === categoryIndex ? (
                                            <Form.Control
                                                type="text"
                                                value={category.name}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleCategoryNameChange(categoryIndex, e.target.value);
                                                }}
                                                                                                 onKeyDown={(e) => {
                                                     e.stopPropagation();
                                                     handleCategoryNameKeyDown(e, categoryIndex);
                                                 }}
                                                onBlur={handleCategoryNameBlur}
                                                onClick={(e) => e.stopPropagation()}
                                                className="editable-category-name"
                                                autoFocus
                                                size="sm"
                                            />
                                        ) : (
                                            <strong 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleCategoryNameClick(categoryIndex);
                                                }}
                                                style={{ cursor: 'pointer' }}
                                                title="Klik om te bewerken"
                                            >
                                                {category.name}
                                            </strong>
                                        )}
                                    </div>
                                    <div className="d-flex gap-3 align-items-center">
                                         <div 
                                             className="drag-handle" 
                                             title="Sleep om categorie te verplaatsen"
                                             draggable="true"
                                             onDragStart={(e) => handleCategoryDragStart(e, categoryIndex)}
                                             onDragEnd={handleCategoryDragEnd}
                                             onMouseDown={(e) => e.stopPropagation()}
                                         >
                                             <div className="drag-handle-arrows">
                                                 <span>↑</span>
                                                 <span>↓</span>
                                             </div>
                                         </div>
                                         <Button
                                             variant="danger"
                                             size="sm"
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 deleteCategory(categoryIndex);
                                             }}
                                             title="Verwijder categorie"
                                             style={{ 
                                                 backgroundColor: '#dc3545',
                                                 borderColor: '#dc3545',
                                                 color: 'white',
                                                 width: '32px',
                                                 height: '32px'
                                             }}
                                         >
                                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                 <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14zM10 11v6M14 11v6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                             </svg>
                                         </Button>
                                     </div>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body className="category-controls">
                                {/* Questions Section */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="mb-0">Vragen in deze categorie</h6>
                                    <Button 
                                        variant="success" 
                                        size="sm" 
                                        onClick={() => addQuestion(categoryIndex)}
                                        className="add-button-green"
                                    >
                                        + Vraag toevoegen
                                    </Button>
                                </div>

                                {category.questions.length === 0 && (
                                    <Alert variant="secondary" className="mb-3">
                                        Geen vragen in deze categorie. Voeg een vraag toe.
                                    </Alert>
                                )}

                                                                 <Accordion 
                                     className="mt-3"
                                     activeKey={openQuestionAccordions[categoryIndex] || []}
                                     onSelect={(eventKey) => {
                                         // Prevent accordion toggle when editing any input
                                         if (editingCategoryIndex === null && editingQuestionIndex === null) {
                                             const categoryQuestionAccordions = openQuestionAccordions[categoryIndex] || [];
                                             const newAccordions = categoryQuestionAccordions.includes(eventKey) 
                                                 ? categoryQuestionAccordions.filter(key => key !== eventKey)
                                                 : [...categoryQuestionAccordions, eventKey];
                                             setOpenQuestionAccordions(prev => ({
                                                 ...prev,
                                                 [categoryIndex]: newAccordions
                                             }));
                                         }
                                     }}
                                 >
                                                                           {category.questions.map((question, questionIndex) => {
                                          const questionKey = `${categoryIndex}-${questionIndex}`;
                                          const isSourceMode = answerSourceCodeModes[questionKey];
                                          const editingKey = `${categoryIndex}-${questionIndex}`;
                                          
                                          return (
                                              <Fragment key={question.id}>
                                                  {/* Drop indicator before question */}
                                                  <div 
                                                      className={`drop-indicator ${
                                                          dragOverQuestionIndex === questionIndex && 
                                                          draggedQuestionCategoryIndex === categoryIndex &&
                                                          questionDropIndicatorPosition === 'before' ? 'active' : ''
                                                      }`}
                                                  />
                                                  
                                                  <Accordion.Item 
                                                      eventKey={questionIndex.toString()}
                                                      onDragOver={(e) => handleQuestionDragOver(e, categoryIndex, questionIndex)}
                                                      onDragLeave={handleQuestionDragLeave}
                                                      onDrop={(e) => handleQuestionDrop(e, categoryIndex, questionIndex)}
                                                      className={`${
                                                          draggedQuestionIndex === questionIndex && 
                                                          draggedQuestionCategoryIndex === categoryIndex ? 'dragging' : ''
                                                      } ${
                                                          dragOverQuestionIndex === questionIndex && 
                                                          draggedQuestionCategoryIndex === categoryIndex ? 'drag-over' : ''
                                                      }`}
                                                  >
                                                      <Accordion.Header>
                                                          <div className="d-flex align-items-center justify-content-between w-100">
                                                              <div className="flex-grow-1 me-3">
                                                                  {editingQuestionIndex === editingKey ? (
                                                                      <Form.Control
                                                                          type="text"
                                                                          value={question.question}
                                                                          onChange={(e) => {
                                                                              e.stopPropagation();
                                                                              handleQuestionTextChange(categoryIndex, questionIndex, e.target.value);
                                                                          }}
                                                                                                                                                     onKeyDown={(e) => {
                                                                               e.stopPropagation();
                                                                               handleQuestionTextKeyDown(e, categoryIndex, questionIndex);
                                                                           }}
                                                                          onBlur={handleQuestionTextBlur}
                                                                          onClick={(e) => e.stopPropagation()}
                                                                          className="editable-category-name"
                                                                          autoFocus
                                                                          size="sm"
                                                                      />
                                                                  ) : (
                                                                      <span 
                                                                          onClick={(e) => {
                                                                              e.stopPropagation();
                                                                              handleQuestionTextClick(categoryIndex, questionIndex);
                                                                          }}
                                                                          style={{ cursor: 'pointer' }}
                                                                          title="Klik om te bewerken"
                                                                      >
                                                                          {question.question}
                                                                      </span>
                                                                  )}
                                                              </div>
                                                              <div className="d-flex gap-2 align-items-center">
                                                                  <div 
                                                                      className="drag-handle" 
                                                                      title="Sleep om vraag te verplaatsen"
                                                                      draggable="true"
                                                                      onDragStart={(e) => handleQuestionDragStart(e, categoryIndex, questionIndex)}
                                                                      onDragEnd={handleQuestionDragEnd}
                                                                      onMouseDown={(e) => e.stopPropagation()}
                                                                      style={{ width: '32px', height: '32px' }}
                                                                  >
                                                                      <div className="drag-handle-arrows">
                                                                          <span>↑</span>
                                                                          <span>↓</span>
                                                                      </div>
                                                                  </div>
                                                                  <Button
                                                                      variant="danger"
                                                                      size="sm"
                                                                      onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          deleteQuestion(categoryIndex, questionIndex);
                                                                      }}
                                                                      title="Verwijder vraag"
                                                                      style={{ width: '32px', height: '32px' }}
                                                                  >
                                                                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                          <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14zM10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                      </svg>
                                                                  </Button>
                                                              </div>
                                                          </div>
                                                      </Accordion.Header>
                                                                                                       <Accordion.Body className="question-controls">
                                                          <Form.Group className="mb-3">
                                                              <Form.Label>Antwoord</Form.Label>
                                                              
                                                              {/* Rich Text Editor Toolbar */}
                                                              <div className="border rounded-top p-2 bg-light">
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => formatAnswerText(questionKey, 'bold')}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      <strong>B</strong>
                                                                  </Button>
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => formatAnswerText(questionKey, 'italic')}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      <em>I</em>
                                                                  </Button>
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => formatAnswerText(questionKey, 'underline')}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      <u>U</u>
                                                                  </Button>
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => formatAnswerText(questionKey, 'insertUnorderedList')}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      • List
                                                                  </Button>
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => formatAnswerText(questionKey, 'insertOrderedList')}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      1. List
                                                                  </Button>
                                                                  <Button
                                                                      variant="outline-secondary"
                                                                      size="sm"
                                                                      className="me-2"
                                                                      onClick={() => {
                                                                          const url = prompt('Enter URL:');
                                                                          if (url) formatAnswerText(questionKey, 'createLink', url);
                                                                      }}
                                                                      disabled={isSourceMode}
                                                                  >
                                                                      🔗 Link
                                                                  </Button>
                                                                  <Button
                                                                      variant={isSourceMode ? "primary" : "outline-secondary"}
                                                                      size="sm"
                                                                      className="ms-auto"
                                                                      onClick={() => handleAnswerSourceCodeToggle(categoryIndex, questionIndex)}
                                                                  >
                                                                      {isSourceMode ? "WYSIWYG" : "</>"}
                                                                  </Button>
                                                              </div>
                                                              
                                                              {/* Editor Area */}
                                                              {isSourceMode ? (
                                                                  <Form.Control
                                                                      ref={ref => answerEditorRefs.current[questionKey] = ref}
                                                                      as="textarea"
                                                                      rows={6}
                                                                      value={question.answer || ''}
                                                                      onChange={(e) => handleQuestionChange(categoryIndex, questionIndex, 'answer', e.target.value)}
                                                                      style={{
                                                                          fontFamily: 'monospace',
                                                                          fontSize: '0.9rem',
                                                                          borderTop: 'none',
                                                                          borderTopLeftRadius: '0',
                                                                          borderTopRightRadius: '0'
                                                                      }}
                                                                      placeholder="Voer hier de HTML-code in..."
                                                                  />
                                                              ) : (
                                                                  <div
                                                                      ref={ref => answerEditorRefs.current[questionKey] = ref}
                                                                      contentEditable="true"
                                                                      onInput={(e) => handleAnswerTextChange(categoryIndex, questionIndex, e)}
                                                                      onClick={() => handleAnswerEditorClick(questionKey)}
                                                                      className="rich-text-editor"
                                                                      style={{
                                                                          minHeight: '150px',
                                                                          maxHeight: '300px',
                                                                          overflowY: 'auto',
                                                                          border: '1px solid #ced4da',
                                                                          borderTop: 'none',
                                                                          borderBottomLeftRadius: '0.25rem',
                                                                          borderBottomRightRadius: '0.25rem',
                                                                          padding: '0.75rem',
                                                                          backgroundColor: 'white',
                                                                          outline: 'none'
                                                                      }}
                                                                      suppressContentEditableWarning={true}
                                                                  />
                                                              )}
                                                          </Form.Group>
                                                      </Accordion.Body>
                                                  </Accordion.Item>
                                                  
                                                  {/* Drop indicator after question */}
                                                  <div 
                                                      className={`drop-indicator ${
                                                          dragOverQuestionIndex === questionIndex && 
                                                          draggedQuestionCategoryIndex === categoryIndex &&
                                                          questionDropIndicatorPosition === 'after' ? 'active' : ''
                                                      }`}
                                                  />
                                              </Fragment>
                                          );
                                      })}
                                  </Accordion>
                             </Accordion.Body>
                        </Accordion.Item>
                        
                        {/* Drop indicator after item */}
                        <div 
                            className={`drop-indicator ${
                                dragOverIndex === categoryIndex && dropIndicatorPosition === 'after' ? 'active' : ''
                            }`}
                                                 />
                                           </Fragment>
                  ))}   
             </Accordion>
        </div>
    );
} 